import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface ListingPhotoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  photoId: number;
  photoUuid: string;
}

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingPhotoUploadRecord>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/photos/request`,
  );
